const TYPE = "saldoOver";

const saldoReservaModule = {
  update: async (dbConnection, idPedido, qtd, tipo, idIntegracaoVendedor) => {
    let saldoOver = await getDocSaldoOver(dbConnection);

    saldoOver.pedidos.push({
      _id: idPedido,
      qtd: qtd,
      tipo: tipo,
      idIntegracaoVendedor,
    });

    await dbConnection.put(saldoOver);
  },

  getSaldoOver: async (dbConnection, idIntegracaoVendedor) => {
    let saldoOver = await getDocSaldoOver(dbConnection);

    let total = {
      qtdAcrescentar: 0,
      qtdDescontar: 0,
    };

    if (saldoOver.pedidos.length) {
      let pedidos = saldoOver.pedidos.filter(
        (ped) => ped.idIntegracaoVendedor === idIntegracaoVendedor
      );

      if (pedidos.length) {
        for (let pedido of pedidos) {
          if (pedido.tipo === "A") {
            total.qtdAcrescentar += pedido.qtd;
          } else {
            total.qtdDescontar += pedido.qtd;
          }
        }
      }
    }

    return total;
  },

  removeSaldoOver: async (dbConnection, idPedido) => {
    let saldoOver = await getDocSaldoOver(dbConnection);
    let qtdPedidos = saldoOver.pedidos.length;
    let pedidos = saldoOver.pedidos.filter((item) => item._id !== idPedido);
    saldoOver.pedidos = pedidos;

    if (saldoOver.pedidos.length !== qtdPedidos) {
      await dbConnection.put(saldoOver);
    }
  },
};

const getDocSaldoOver = async (dbConnection) => {
  let saldoOver = null;
  const query = {
    selector: {
      type: { $eq: TYPE },
    },
    limit: 1,
  };

  let result = await dbConnection.find(query);

  if (result.docs.length) {
    saldoOver = result.docs[0];
  } else {
    await dbConnection.post({
      type: TYPE,
      pedidos: [],
    });
    result = await dbConnection.find(query);
    if (result.docs.length) {
      saldoOver = result.docs[0];
    } else {
      throw new Error("Não foi possível gravar o saldo over");
    }
  }

  return saldoOver;
};

export default saldoReservaModule;
